const loadHtml2Pdf = (rootElement) => {
  if (window.html2pdf) return Promise.resolve();
  if (window.__html2pdfLoading) return window.__html2pdfLoading;

  const scriptUrl =
    rootElement?.dataset?.html2pdfUrl ||
    document.querySelector('[data-html2pdf-url]')?.dataset?.html2pdfUrl;

  if (!scriptUrl) {
    return Promise.reject(new Error('html2pdf script URL not found.'));
  }

  window.__html2pdfLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.dataset.html2pdfLoader = 'true';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load html2pdf.'));
    document.head.appendChild(script);
  });

  return window.__html2pdfLoading;
};

if (!customElements.get('return-form')) {
  customElements.define(
    'return-form',
    class ReturnForm extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.showFormWithSelector();
        this.uploadFile();
        this.signaturePreview();
        const downloadbtn = this.querySelector('button#downloadForm');
        downloadbtn.addEventListener('click', this.downloadForm.bind(this));
      }
      uploadFile() {
        const fileInput = this.querySelector('input#signature');
        const uploadBtn = this.querySelector('button#uploadFile');

        if (fileInput && uploadBtn) {
          uploadBtn.addEventListener('click', () => {
            fileInput.click();
          });
        }
      }
      signaturePreview() {
        const fileInput = this.querySelector('input#signature');
        const previewElement = this.querySelector('#previewSignature>img');

        if (!fileInput) return;

        fileInput.addEventListener('change', function (event) {
          const file = event.target.files[0];
          if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
              previewElement.src = e.target.result;
              previewElement.classList.remove('leo-hidden');
            };
            reader.readAsDataURL(file);
          }
        });
      }
      downloadForm = () => {
        try {
          const formElement = this;
          if (!formElement) {
            console.error(`Form not found`);
            return;
          }
          const clone = formElement?.cloneNode(true);

          // Create a wrapper div and append the cloned content to it
          const wrapper = document.createElement('div');
          wrapper.style.width = '750px'; // A4 width at 96 DPI
          wrapper.style.maxWidth = '750px';
          wrapper.style.paddingLeft = '40px';
          wrapper.style.backgroundColor = '#fff';
          wrapper.appendChild(clone);

          // Generate timestamp for unique filename
          const timestamp = new Date()
            .toISOString()
            .replace(/[:.]/g, '-')
            .slice(0, 19);

          const options = {
            margin: [10, 0, 0, 0],
            filename: 'return-form'
              ? `return-form-${timestamp}.pdf`
              : `return-form-${timestamp}.pdf`,
            image: {type: 'jpeg', quality: 1},
            html2canvas: {
              scale: 3,
              backgroundColor: '#ffffff',
              scrollX: 0,
              scrollY: 0,
              useCORS: true,
            },
            jsPDF: {unit: 'mm', format: 'legal', orientation: 'portrait'},
          };

          // Option 1: Current approach (append/remove)
          const container = document.createElement('div');
          container.style.position = 'fixed';
          container.style.top = '-10000px';
          container.style.left = '-10000px';
          container.appendChild(wrapper);
          document.body.appendChild(container);

          // Wait for images to load
          Promise.all([
            ...[...wrapper.querySelectorAll('img')].map((img) => {
              if (img.complete) return Promise.resolve();
              return new Promise((resolve) => {
                img.onload = img.onerror = resolve;
              });
            }),
            loadHtml2Pdf(this),
          ]).then(() => {
            html2pdf()
              .set(options)
              .from(wrapper)
              .save()
              .then(() => {
                document.body.removeChild(container); // Clean up
              })
              .catch((error) => {
                document.body.removeChild(container); // Clean up on error
                console.error('PDF generation failed:', error);
              });
          });
        } catch (error) {
          console.error('Error during form download:', error);
        }
      };
      showFormWithSelector() {
        const targetSelector = this?.dataset.selector;
        const target = document.querySelector(targetSelector);
        if (targetSelector && target) {
          target.appendChild(this);
        }
      }
    },
  );
}
